<template>
<div class="k-page-content">
	<div class="messageIndex">
		<div class="left box" v-loading="loading">
			<div class="title">
				<span class="t1">消息</span>
				<span class="t2" @click="gomore()">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="con" v-if="tableData.data.length > 0">
				<li v-for="(item,index) in tableData.data" :key="index" @click="goUrl(item)">
					<div :class="item.send_name_jian == '系统' ? 'name two' : 'name'">{{item.send_name_jian}}</div>
					<div class="content">
						<span class="read" v-if="item.is_read == 0"></span>
						<p class="t1">{{item.content}}</p>
						<p class="t2">
							<span>发件人：{{item.send_name}}</span>
							<span>{{item.send_time}}</span>
						</p>
					</div>
				</li>
			</ul>
			<ul class="con conNull" v-else>
				<img src="../assets/images/null_data.png" alt="">
				<p>暂无内容</p>
			</ul>
		</div>
		<div class="right box" v-loading="loading">
			<div class="title">
				<span class="t1">公告</span>
				<span class="t2" @click="gomoreNews()">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="notice" v-if="tableData2.data.length > 0">
				<li v-for="(item,index) in tableData2.data" :key="index" @click="goUrlNews(item)">
					<p>{{item.title}}</p>
					<span>{{item.create_time}}</span>
				</li>
			</ul>
			<ul class="notice conNull" v-else>
				<img src="../assets/images/null_data.png" alt="">
				<p>暂无内容</p>
			</ul>
		</div>
	</div>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
		  tableData: {
		      data: []
		  },
		  tableData2: {
		      data: []
		  },
		  params:{
			  pagesize: 20,
			  page: 1,
		  }
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.getMessage()
		this.getNews()
	},
	methods: {
		gomore(){
			this.$router.push('/Message')
		},
		gomoreNews(){
			this.$router.push('/news')
		},
		getMessage(){
			this.$api.get('/admin/news/message/list',this.params).then(res => {
			  if (res.code === 0) {
				  this.tableData.data = res.data.data;
				  this.tableData.data.forEach((item,index) => {
					  if(item.send_name != '系统'){
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name.charAt(0))
					  }else{
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name)
					  }
				  })
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		getNews(){
			this.loading = true
			this.$api.get('/admin/news/message/getnoticereadlist').then(res => {
			  if (res.code === 0) {
				  this.tableData2.data = res.data.readList;
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		goUrl(item){
			this.loading = true
			this.$api.get('/admin/news/message/info',{id:item.id}).then(res => {
			  if (res.code === 0) {
				  if(item.type == 2){
				  	this.$router.push({
				  		name: 'Checklist',
						query:{ type: item.status}
				  	});
				  }else{
					 this.$router.push({
					 	name: 'MessageDetail',
					 	query:{ id: item.id}
					 }); 
				  }
			  } else {
				 this.$message.error(res.msg);
			  }
			})
		},
		goUrlNews(item){
			this.$router.push({
				name: 'NewsDetail',
				query:{ id: item.id}
			}); 
		}
	}
}
</script>
<style lang="scss" scoped>
	.messageIndex{
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		gap: 20px;
		.box{
			background-color: #fff;
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03);
			border-radius: 8px;
			min-height: 400px;
			padding: 20px;
			box-sizing: border-box;
		}
		.left{
			flex: 1;
		}
		.right{
			width: 420px;
		}
		.title{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 16px;
			margin-bottom: 16px;
			border-bottom: 1px solid #f0f0f0;
			.t1{
				color: #303133;
				font-size: 16px;
				font-weight: 600;
				display: flex;
				align-items: center;
				padding-left: 12px;
				position: relative;
				&::before{
					content: "";
					display: inline-block;
					width: 4px;
					height: 18px;
					background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
					border-radius: 2px;
					position: absolute;
					left: 0;
				}
			}
			.t2{
				font-size: 13px;
				color: #606266;
				cursor: pointer;
				display: flex;
				align-items: center;
				transition: color 0.2s ease;
				&:hover{
					color: #1e3c72;
				}
				.el-icon-arrow-right{
					margin-left: 4px;
					font-size: 12px;
				}
			}
		}
		.con{
			max-height: calc(100vh - 220px);
			overflow-y: auto;
			padding-right: 8px;
			box-sizing: border-box;
			li{
				display: flex;
				align-items: flex-start;
				padding: 14px 0;
				cursor: pointer;
				border-bottom: 1px solid #f5f5f5;
				transition: background-color 0.2s ease;
				&:hover{
					background-color: #fafafa;
				}
				&:last-child{
					border-bottom: none;
				}
				.name{
					width: 44px;
					height: 44px;
					background: #5E98FF;
					border-radius: 50%;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					font-weight: 600;
					font-size: 18px;
					color: #FFFFFF;
					flex-shrink: 0;
					&.two{
						font-size: 13px;
						background: #5E98FF;
					}
				}
				.content{
					flex: 1;
					margin-left: 14px;
					overflow: hidden;
					position: relative;
					.t1{
						font-weight: 500;
						font-size: 14px;
						color: #303133;
						line-height: 22px;
						height: 22px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-bottom: 8px;
						padding-right: 24px;
					}
					.t2{
						font-weight: 400;
						font-size: 12px;
						color: #909399;
						line-height: 18px;
						display: flex;
						justify-content: space-between;
					}
					.read{
						width: 8px;
						height: 8px;
						background: #F56C6C;
						border-radius: 50%;
						position: absolute;
						right: 0;
						top: 6px;
					}
				}
			}
		}
		.notice{
			max-height: calc(100vh - 220px);
			overflow-y: auto;
			padding-right: 8px;
			box-sizing: border-box;
			li{
				display: flex;
				justify-content: space-between;
				height: 44px;
				align-items: center;
				cursor: pointer;
				padding: 0 12px;
				border-radius: 6px;
				transition: background-color 0.2s ease;
				&:hover{
					background-color: #f5f7fa;
				}
				p{
					font-weight: 500;
					font-size: 14px;
					color: #303133;
					height: 44px;
					line-height: 44px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width: calc(100% - 100px);
					display: block;
				}
				span{
					font-weight: 400;
					font-size: 12px;
					color: #909399;
				}
			}
		}
	}
	.conNull{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 200px;
		img{
			width: 64px;
			height: 64px;
			opacity: 0.6;
		}
		p{
			margin-top: 16px;
			font-size: 13px;
			color: #909399;
		}
	}
</style>